import React from 'react';
import { Label } from 'semantic-ui-react';
import RequestAttachmentLabel from './RequestAttachmentLabel';

const RequestAttachmentLabels = ({ attachments }) => (
  <Label.Group>
    {attachments.map((attachment) => (
      <RequestAttachmentLabel
        attachment={attachment}
        key={`request_attachment_label${attachment.attachment_id}`}
      />
    ))}
  </Label.Group>
);

export default RequestAttachmentLabels;
